import { useState, useEffect } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const testimonials = [
  {
    name: 'Carlos Eduardo',
    city: 'Campinas – SP',
    rating: 5,
    text: 'Levei meu BMW 320i para fazer a troca de correia dentada e fiquei impressionado com o profissionalismo da equipe. Serviço impecável, prazo cumprido e preço justo. Com certeza voltarei!',
    initials: 'CE',
    photo: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20smiling%20portrait%2C%20clean%20white%20background%2C%20confident%20friendly%20expression%2C%20short%20dark%20hair%2C%20business%20casual%2C%20high%20quality%20headshot%20photography&width=120&height=120&seq=t1&orientation=squarish',
  },
  {
    name: 'Fernanda Oliveira',
    city: 'Campinas – SP',
    rating: 5,
    text: 'Minha Mercedes estava com problema no sistema de freios e a Miki Motors resolveu tudo rapidamente. Diagnóstico preciso, peças originais e atendimento excelente. Super recomendo!',
    initials: 'FO',
    photo: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20smiling%20portrait%2C%20clean%20white%20background%2C%20warm%20friendly%20expression%2C%20dark%20hair%2C%20business%20casual%2C%20high%20quality%20headshot%20photography&width=120&height=120&seq=t2&orientation=squarish',
  },
  {
    name: 'Ricardo Mendes',
    city: 'Valinhos – SP',
    rating: 5,
    text: 'Tenho um Audi A4 e sempre trago aqui para manutenção. A equipe conhece muito bem os importados, usam produtos de qualidade e o serviço é sempre entregue no prazo. Nota 10!',
    initials: 'RM',
    photo: 'https://readdy.ai/api/search-image?query=professional%20latin%20man%20smiling%20portrait%2C%20clean%20light%20background%2C%20relaxed%20confident%20expression%2C%20beard%2C%20casual%20shirt%2C%20high%20quality%20headshot%20photography&width=120&height=120&seq=t3&orientation=squarish',
  },
  {
    name: 'Juliana Costa',
    city: 'Campinas – SP',
    rating: 5,
    text: 'Meu Land Rover estava com problema na suspensão e a Miki Motors fez um trabalho incrível. Carro voltou como novo! Atendimento humanizado e transparente do início ao fim.',
    initials: 'JC',
    photo: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20smiling%20portrait%2C%20clean%20light%20background%2C%20happy%20warm%20expression%2C%20long%20dark%20hair%2C%20elegant%20casual%2C%20high%20quality%20headshot%20photography&width=120&height=120&seq=t4&orientation=squarish',
  },
  {
    name: 'Marcos Vieira',
    city: 'Sumaré – SP',
    rating: 5,
    text: 'Já indiquei a Miki Motors para vários amigos que têm importados. Serviço de altíssima qualidade, equipe super qualificada e preço honesto. Não levo meu Porsche em outro lugar!',
    initials: 'MV',
    photo: 'https://readdy.ai/api/search-image?query=professional%20middle%20aged%20brazilian%20man%20smiling%20portrait%2C%20clean%20white%20background%2C%20trustworthy%20confident%20expression%2C%20short%20hair%2C%20polo%20shirt%2C%20high%20quality%20headshot%20photography&width=120&height=120&seq=t5&orientation=squarish',
  },
];

const INTERVAL_MS = 4500;

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');
  const { ref: headerRef, visible: headerVisible } = useScrollReveal();
  const { ref: cardRef, visible: cardVisible } = useScrollReveal();

  const goTo = (idx: number, dir: 'next' | 'prev' = 'next') => {
    if (animating) return;
    setDirection(dir);
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 350);
  };

  const prev = () => {
    const idx = current === 0 ? testimonials.length - 1 : current - 1;
    goTo(idx, 'prev');
  };

  const next = () => {
    const idx = current === testimonials.length - 1 ? 0 : current + 1;
    goTo(idx, 'next');
  };

  // Auto-advance
  useEffect(() => {
    const timer = setInterval(() => {
      const idx = (current + 1) % testimonials.length;
      goTo(idx, 'next');
    }, INTERVAL_MS);
    return () => clearInterval(timer);
  }, [current, animating]);

  const t = testimonials[current];

  const slideStyle: React.CSSProperties = {
    transition: 'opacity 0.35s ease, transform 0.35s ease',
    opacity: animating ? 0 : 1,
    transform: animating
      ? direction === 'next' ? 'translateX(-24px)' : 'translateX(24px)'
      : 'translateX(0)',
  };

  return (
    <section id="depoimentos" className="relative py-24 overflow-hidden" style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 20%, #e8e8e8 40%, #f5f5f5 60%, #ebebeb 80%, #ffffff 100%)' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#aaaaaa]/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#aaaaaa]/40 to-transparent"></div>
        <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(200,200,200,0.35) 0%, transparent 65%)' }}></div>
        <div className="absolute -top-20 -left-20 w-[400px] h-[400px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(180,180,180,0.25) 0%, transparent 70%)' }}></div>
        <div className="absolute -bottom-10 -right-10 w-[400px] h-[400px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(160,160,160,0.2) 0%, transparent 70%)' }}></div>
        <div className="absolute top-0 left-0 w-full h-full" style={{ background: 'linear-gradient(105deg, rgba(255,255,255,0.9) 0%, rgba(210,210,210,0.3) 30%, rgba(255,255,255,0.6) 50%, rgba(195,195,195,0.25) 70%, rgba(255,255,255,0.9) 100%)' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block text-sm font-semibold tracking-widest uppercase mb-4" style={{ color: '#888888' }}>
            O que dizem nossos clientes
          </span>
          <h2
            className="text-4xl md:text-5xl font-black"
            style={{ fontFamily: "'Playfair Display', serif", color: '#111111' }}
          >
            <span style={{ color: '#444444' }}>"</span> Depoimentos <span style={{ color: '#444444' }}>"</span>
          </h2>
        </div>

        {/* Main testimonial */}
        <div
          ref={cardRef as React.RefObject<HTMLDivElement>}
          className={`max-w-3xl mx-auto transition-all duration-700 delay-150 ${cardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div
            className="rounded-3xl p-10 md:p-14 relative border"
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 40%, #eeeeee 100%)',
              borderColor: 'rgba(170,170,170,0.5)',
            }}
          >
            {/* Quote mark */}
            <div className="absolute top-8 right-10 text-9xl font-serif leading-none select-none" style={{ color: 'rgba(150,150,150,0.12)' }}>
              "
            </div>

            {/* Animated content */}
            <div style={slideStyle}>
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg" style={{ color: '#aaaaaa' }}></i>
                ))}
              </div>

              {/* Text */}
              <p
                className="text-xl md:text-2xl leading-relaxed mb-10 relative z-10"
                style={{ fontFamily: "'Playfair Display', serif", color: '#444444' }}
              >
                "{t.text}"
              </p>

              {/* Author with round photo */}
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border-2" style={{ borderColor: 'rgba(170,170,170,0.5)' }}>
                  <img
                    src={t.photo}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.style.background = 'linear-gradient(135deg, #777777 0%, #aaaaaa 50%, #cccccc 100%)';
                        parent.style.display = 'flex';
                        parent.style.alignItems = 'center';
                        parent.style.justifyContent = 'center';
                        parent.innerHTML = `<span style="color:#fff;font-weight:900;font-size:18px">${t.initials}</span>`;
                      }
                    }}
                  />
                </div>
                <div>
                  <div className="font-bold text-base" style={{ color: '#333333' }}>{t.name}</div>
                  <div className="text-sm mt-0.5" style={{ color: '#999999' }}>{t.city}</div>
                </div>
              </div>
            </div>

            {/* Progress bar */}
            <div className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-3xl overflow-hidden" style={{ background: 'rgba(170,170,170,0.2)' }}>
              <div
                key={current}
                className="h-full rounded-full"
                style={{
                  background: 'linear-gradient(90deg, #777777, #aaaaaa)',
                  animation: `progressBar ${INTERVAL_MS}ms linear forwards`,
                }}
              />
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-between mt-8">
            {/* Dots */}
            <div className="flex gap-2 items-center">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i, i > current ? 'next' : 'prev')}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${
                    i === current ? 'w-8 h-2' : 'w-2 h-2 hover:bg-[#bbbbbb]'
                  }`}
                  style={i === current ? { background: 'linear-gradient(90deg, #777777, #aaaaaa)' } : { background: '#cccccc' }}
                />
              ))}
            </div>

            {/* Arrows */}
            <div className="flex gap-3">
              <button
                onClick={prev}
                className="w-12 h-12 flex items-center justify-center rounded-full border transition-all duration-300 cursor-pointer hover:bg-[#f0f0f0]"
                style={{ borderColor: 'rgba(150,150,150,0.5)', color: '#777777' }}
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-12 h-12 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer"
                style={{ background: 'linear-gradient(135deg, #666666 0%, #999999 50%, #bbbbbb 100%)', color: '#ffffff' }}
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Google rating badge */}
        <div className="flex justify-center mt-12">
          <div className="inline-flex items-center gap-3 rounded-full px-6 py-3 border" style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%)', borderColor: 'rgba(170,170,170,0.5)' }}>
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((i) => (
                <i key={i} className="ri-star-fill text-sm" style={{ color: '#aaaaaa' }}></i>
              ))}
            </div>
            <span className="font-bold" style={{ color: '#444444' }}>5.0</span>
            <span className="text-sm" style={{ color: '#999999' }}>no Google</span>
          </div>
        </div>
      </div>

      {/* Keyframe for progress bar */}
      <style>{`
        @keyframes progressBar {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </section>
  );
}
